// 轮播 CTA 按钮修复：body 下固定定位透明遮罩盖住按钮，保证一定能点击+悬浮
(function() {
  'use strict';

  var processedKey = 'data-slideshow-cta-overlay';
  var hoverClass = 'slideshow-cta-hover';
  var containerId = 'slideshow-cta-overlays';
  var linkToOverlay = new WeakMap();

  function getLinks() {
    var out = [];
    document.querySelectorAll('slideshow-component .banner__buttons a[href], .slideshow .banner__buttons a[href]').forEach(function(a) {
      if (a.getAttribute('href') && a.getAttribute('href') !== '#') out.push(a);
    });
    return out;
  }

  function positionOverlays() {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('[data-cta-link]').forEach(function(ov) {
      var link = linkToOverlay.get(ov);
      if (!link || !link.isConnected || !link.getBoundingClientRect) {
        ov.remove();
        return;
      }
      var r = link.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) {
        ov.style.display = 'none';
        return;
      }
      ov.style.display = 'block';
      ov.style.top = (r.top + window.scrollY) + 'px';
      ov.style.left = (r.left + window.scrollX) + 'px';
      ov.style.width = r.width + 'px';
      ov.style.height = r.height + 'px';
    });
  }

  function createOverlay(link) {
    var overlay = document.createElement('div');
    overlay.setAttribute('data-cta-link', '1');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.cssText = 'position:absolute; left:0; top:0; z-index:2147483647; cursor:pointer; display:block; pointer-events:auto;';
    linkToOverlay.set(overlay, link);
    overlay.addEventListener('mouseenter', function() {
      link.classList.add(hoverClass);
    });
    overlay.addEventListener('mouseleave', function() {
      link.classList.remove(hoverClass);
    });
    overlay.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (link.href && link.getAttribute('aria-disabled') !== 'true') {
        window.location.href = link.href;
      }
    });
    return overlay;
  }

  function init() {
    var links = getLinks();
    if (links.length === 0) {
      setTimeout(init, 400);
      return;
    }

    var container = document.getElementById(containerId);
    if (!container) {
      container = document.createElement('div');
      container.id = containerId;
      container.style.cssText = 'position:absolute; left:0; top:0; width:0; height:0; overflow:visible; pointer-events:none; z-index:2147483647;';
      document.body.appendChild(container);
    }
    container.style.pointerEvents = 'none';

    links.forEach(function(link) {
      if (link.getAttribute(processedKey)) return;
      link.setAttribute(processedKey, '1');
      var overlay = createOverlay(link);
      overlay.style.pointerEvents = 'auto';
      container.appendChild(overlay);
    });

    positionOverlays();

    if (!container._listenersAttached) {
      container._listenersAttached = true;
      var slider = document.querySelector('slideshow-component [id^="Slider-"]');
      if (slider) slider.addEventListener('scroll', positionOverlays);
      window.addEventListener('resize', positionOverlays);
      window.addEventListener('scroll', positionOverlays, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 200);
  }

  var observer = new MutationObserver(function() {
    setTimeout(init, 200);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
